// extracted by mini-css-extract-plugin
export default {"formSection":"FormSection_formSection__LOQvd","condensed":"FormSection_condensed__DQSZT"};